export default __webpack_public_path__ + "static/media/shutterstock_243756841_formacion_2.571e4ae8.webp";